const experiences = [
  {
    key: 1,
    image: "/images/nerds.png",
    title: "Neural Data Science Lab (NerDS)",
    date: "October 2025 - Present",
    location: "Philadelphia, PA",
    position: "Machine Learning Researcher",
    description: "Time series forecasting on neural population activity",
    link: "Experience-Page"
  },
  {
    key: 2,
    image: "/images/meta.png",
    title: "Meta",
    date: "June 2025 - August 2025",
    location: "Menlo Park, CA",
    position: "Software Engineer Intern",
    description: "WhatsApp Cloud API Calling",
    link: "Experience-Page"
  },
  {
    key: 3,
    image: "/images/pomonacs.png",
    title: "Computer Science Teaching Assistant",
    date: "August 2022 - December 2024",
    location: "Claremont, CA",
    position: "Data Structures & Adv. Programming (CS062) Mentor",
    description: "",
    link: "Experience-Page"
  },
  {
    key: 4,
    image: "/images/hp.png",
    title: "HP Inc.",
    date: "May 2024 - August 2024",
    location: "Vancouver, Washington",
    position: "Software Engineer Intern",
    description: "Customer Solutions: HPX",
    link: "Experience-Page"
  },
  {
    key: 5,
    image: "/images/aracala.jpeg",
    title: "ARCALA Research Lab",
    date: "May 2023 - May 2024",
    location: "Irvine, CA",
    position: "Research Assistant",
    description: "",
    link: "Experience-Page"
  },
  {
    key: 6,
    image: "/images/flow.jpeg",
    title: "FlowAI",
    date: "May 2023 - August 2023",
    location: "Austin, TX",
    position: "Software Engineer Intern",
    description: "",
    link: "Experience-Page"
  },
  {
    key: 7,
    image: "/images/qsc.png",
    title: "Quantitative Skills Center Partner",
    date: "January 2023 - May 2023",
    location: "Claremont, CA",
    position: "Computer Science Teaching Partner",
    description: "",
    link: "Experience-Page"
  }
]

export default experiences;
